import { Reveal } from "@/components/Reveal";

const PRODUCE_IMG =
  "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxmaWxtJTIwcHJvZHVjdGlvbiUyMGNhbWVyYSUyMHNldCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc5MTg5MTA1NHww&ixlib=rb-4.1.0&q=85";
const DEVELOP_IMG =
  "https://images.unsplash.com/photo-1625690303837-654c9666d2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxmaWxtJTIwcHJvZHVjdGlvbiUyMGNhbWVyYSUyMHNldCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc5MTg5MTA1NHww&ixlib=rb-4.1.0&q=85";

export default function GoshtaStatement() {
  return (
    <section data-testid="goshta-statement" className="relative bg-[#050505] py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-2 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
            <span>Production / India</span>
            <span className="h-px w-10 bg-[#B79045]/50" aria-hidden="true" />
            <span>Stories / Everywhere</span>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display text-[16vw] font-medium leading-[0.92] tracking-tight text-neutral-100 sm:text-[11vw] lg:text-[8.5vw]">
            MAKE
            <br />
            IT <em className="italic text-[#D4AF37]">MATTER.</em>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-8 max-w-md text-base leading-relaxed text-neutral-400">
            Local insight. Strong execution. Stories with a point of view.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2">
          <Reveal className="group relative overflow-hidden bg-[#0a0a0a] p-8 md:p-12">
            <img
              src={PRODUCE_IMG}
              alt="On-ground film production crew"
              className="absolute inset-0 h-full w-full object-cover opacity-15 transition-opacity duration-700 group-hover:opacity-25"
            />
            <div className="relative">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">01 / Produce</p>
              <h3 className="mt-4 font-display text-3xl text-neutral-100 md:text-4xl">
                Plan it. Build it. <em className="italic">Deliver it.</em>
              </h3>
            </div>
          </Reveal>
          <Reveal delay={0.12} className="group relative overflow-hidden bg-[#0a0a0a] p-8 md:p-12">
            <img
              src={DEVELOP_IMG}
              alt="Cinematic lens with atmospheric light"
              className="absolute inset-0 h-full w-full object-cover opacity-15 transition-opacity duration-700 group-hover:opacity-25"
            />
            <div className="relative">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">02 / Develop</p>
              <h3 className="mt-4 font-display text-3xl text-neutral-100 md:text-4xl">
                Imagine it. Write it. <em className="italic">Shape it.</em>
              </h3>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
